import { render, staticRenderFns } from "./CardActivity.vue?vue&type=template&id=02f20e66&scoped=true&"
import script from "./CardActivity.vue?vue&type=script&lang=js&"
export * from "./CardActivity.vue?vue&type=script&lang=js&"
import style0 from "./CardActivity.vue?vue&type=style&index=0&id=02f20e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f20e66",
  null
  
)

export default component.exports